import axios from 'axios';

const baseURL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';

export const customerPublicApi = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const customerPasswordResetService = {
  requestCode: (cpf: string) =>
    customerPublicApi.post('/users/customer/password-reset/request', { cpf }),

  confirmReset: (cpf: string, code: string, newPassword: string) =>
    customerPublicApi.post('/users/customer/password-reset/confirm', {
      cpf,
      code,
      newPassword,
    }),
};
